<mat-select (selectionChange)="onSelectionChange($event)"
            [placeholder]="filter.label"
            [disableOptionCentering]="true"
            [value]="filter.selectedOptionValue"
            panelClass="dropdown-selection-panel"
            class="dropdown-selection-trigger" [class.active]="filter.active">
  <mat-option *ngFor="let option of filter.options" [value]="option.value" class="option">{{option.label}}</mat-option>
  <mat-option *ngIf="resettable && filter.active" class="clear option">Auswahl zurücksetzen</mat-option>
</mat-select>
<mat-spinner class="spinner" *ngIf="filter.loadingOptions" libCustomSpinner color="#03A85C" diameter="25" strokeWidth="3"></mat-spinner>
